import { safeSessionStorage } from '@toss/storage';

import {
  AI_AUTO_TRIGGER_STORAGE_KEY,
  type AiAutoTriggerData,
} from '@/shared/constants/aiPrompt.constants';

export function saveAiAutoTriggerData(data: AiAutoTriggerData): void {
  safeSessionStorage.set(AI_AUTO_TRIGGER_STORAGE_KEY, JSON.stringify(data));
}

export function loadAiAutoTriggerData(): AiAutoTriggerData | null {
  const raw = safeSessionStorage.get(AI_AUTO_TRIGGER_STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AiAutoTriggerData;
  } catch (e) {
    console.warn(
      '[aiAutoTriggerStorage] Failed to parse sessionStorage data:',
      e,
    );
    return null;
  }
}

export function clearAiAutoTriggerData(): void {
  safeSessionStorage.remove(AI_AUTO_TRIGGER_STORAGE_KEY);
}
